import Footer from "./Footer";

const Sponsors = () => {
    return (
        <div className="flex flex-col items-center bg-black-900_01 sm mobile:pt-[72px]" id="Sponsors">
            <h2 className="font-medium text-[18px] heading ui mobile:mt-[78px] relative !font-switzer text-white-a700_cc mobile:font-monasanssemicondensed">
                Thanks to 
            </h2>
            <h2 className="font-bold text-[52px] mobile:text-[32px] font-bold heading ui text-shadow-ts3 mt-[-2px] relative !font-switzer text-center">Our Sponsors and Partners</h2>
            <div className="mt-[70px] h-[356px] relative md:mx-0 justify-center">
                <div className="desktop:w-[741px] tablet:w-[670px] mobile:mx-[13px] my-auto grid flex-1 grid-cols-3 gap-9 mobile:grid-cols-2">
                    <img src="/images/sponsors/1.svg" alt="sponsor1" 
                        className="h-[83px] mobile:!h-[59px] w-auto object-none mobile:object-contain opacity-70 place-self-center" />
                    <img src="/images/sponsors/2.svg" alt="sponsor2"
                        className="h-[83px] mobile:!h-[59px] w-full object-none mobile:object-contain opacity-70" />
                    <img src="/images/sponsors/3.svg" alt="sponsor3"
                        className="h-[83px] mobile:!h-[59px] w-full object-none mobile:object-contain opacity-70" />
                    <img src="/images/sponsors/4.svg" alt="sponsor4"
                        className="h-[83px] mobile:!h-[59px] w-full object-none mobile:object-contain opacity-70" />
                    <img src="/images/sponsors/5.svg" alt="sponsor5"
                        className="h-[83px] mobile:!h-[59px] w-full object-none mobile:object-contain opacity-70" />
                    <img src="/images/sponsors/6.svg" alt="sponsor6"
                        className="h-[83px] mobile:!h-[59px] w-full object-none mobile:object-contain opacity-70" />
                    <img src="/images/sponsors/7.svg" alt="sponsor7"
                        className="h-[83px] mobile:!h-[59px] w-full object-none mobile:object-contain opacity-70" />
                    <img src="/images/sponsors/8.svg" alt="sponsor8"
                        className="h-[83px] mobile:!h-[59px] w-full object-none mobile:object-contain opacity-70" />
                    <img src="/images/sponsors/9.svg" alt="sponsor9"
                        className="h-[83px] mobile:!h-[62px] w-full object-none mobile:object-contain opacity-70 place-self-center" />
                </div>
            </div>
        </div>
    );
};

export default Sponsors;